import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import { ErrorPage, componentUtils } from '@mtfe/sweet-components';

import tpl from './dom.html';
import style from './style.less';
import WaimaiCrazyCouponList from '../../components/WaimaiCrazyCouponList/script';
import PoiListWithTabs from '../../components/PoiListWithTabs/script';
import SelfTab from '../../components/SelfTab/script';
import PoiListHeader from '../../components/PoiListHeader/script';
import store, { storeRecallBizIdMap } from '../../store/index';
import { fetchAndDispatchDataToStore } from '../../utils/fetchData';
import { renderPoiInfoGWithCoupon } from '../../utils/renderPoi';
import CrazyPoiList from '../../components/CrazyPoiList/script';
import OrderCashBack from '../../components/OrderCashBack/script';
import { experimentIsShowCouponListPriority } from '../../experiment';

const { getOnClickEventName } = componentUtils;
const { createUniqueId } = common;
const { storeCommon } = store;
const wmDomId = createUniqueId();
const tabsContainerId = createUniqueId();
const poiListId = createUniqueId();
const headerId = createUniqueId();
const errorText = '活动太火爆，券被抢光啦，一会再来试试吧';

const CrazyWaimaiModuleReady = () => {
    eventBus.$on('CrazyWaimaiModuleReady', async () => {
        const {
            dom_wm_big_coupon_left: domCrazyCoupon,
            dom_wm_self_coupon: domSelfCoupon,
            dom_wm_every_day_coupon: domWmEveryDayCoupon,
            dom_wm_red_bag: domWmRedBag,
            dom_wm_big_coupon_none: domNoneCrazyCoupon,
            dom_wm_self_promotion_order: domWmSelfPromotionOrder,
        } = storeCommon.structInfo.struct;
        const storeCrazyCoupon = store[domCrazyCoupon.recallBizId];
        const storeSelfCoupon = store[domSelfCoupon.recallBizId];
        const storeWmRedBag = store[domWmRedBag.recallBizId];
        const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
        const storeNoneCrazyCoupon = store[domNoneCrazyCoupon.recallBizId];
        const storeWmOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];

        // eslint-disable-next-line
        console.log('CrazyWaimaiModuleReady: => CrazyWaimaiModuleReady');
        if (storeWmOrderCashBack.isShow) {
            eventBus.$emit('OrderCashBackReady');
        }

        // 券列表Ready
        eventBus.$emit('WaimaiCrazyCouponListReady');

        // 疯狂大额券 和 福利自选券
        const tabsDom = dom.$id(tabsContainerId);
        const poiListDom = dom.$id(poiListId);
        const domHeader = dom.$id(headerId);

        try {
            await Promise.allSettled([
                fetchAndDispatchDataToStore(storeCrazyCoupon),
                fetchAndDispatchDataToStore(storeSelfCoupon),
                fetchAndDispatchDataToStore(storeNoneCrazyCoupon),
            ]);
            storeCrazyCoupon.isShow =
                domCrazyCoupon.isShow &&
                storeCrazyCoupon.poiData.poiList.length > 0;

            storeNoneCrazyCoupon.isShow =
                domNoneCrazyCoupon.isShow &&
                storeNoneCrazyCoupon.poiData.poiList.length > 0;

            storeSelfCoupon.isShow =
                domSelfCoupon.isShow &&
                storeSelfCoupon.poiData.poiList.length > 0;

            const crazyIsShow =
                storeCrazyCoupon.isShow || storeNoneCrazyCoupon.isShow;
            if (crazyIsShow && storeSelfCoupon.isShow) {
                const selfTabDom = SelfTab();
                tabsDom.innerHTML = selfTabDom;
                eventBus.$emit('SelfTabReady');
            } else if (crazyIsShow && !storeSelfCoupon.isShow) {
                const crazyPoiListDom = CrazyPoiList();
                domHeader.style.display = '';
                domHeader.innerHTML = PoiListHeader({
                    headerText: '今日限量大额券',
                    isShowTips: true,
                    leftRecvNum: storeCommon.leftRecvNum,
                });
                poiListDom.innerHTML = crazyPoiListDom;
                eventBus.$emit(
                    getOnClickEventName(storeCrazyCoupon.poiData.recallBizId),
                );
            } else if (!crazyIsShow && storeSelfCoupon.isShow) {
                const poiListWithTabs = new PoiListWithTabs({
                    targetStore: store[storeRecallBizIdMap.wmSelfCoupon],
                    renderFunc: renderPoiInfoGWithCoupon,
                    isSticky: false,
                });
                const selfCouponPoiListDom = poiListWithTabs.getComponent();
                domHeader.style.display = '';
                domHeader.innerHTML = PoiListHeader({
                    headerText: '常规自选券',
                    isShowTips: false,
                    isSticky: false,
                });
                poiListDom.innerHTML = selfCouponPoiListDom;
                poiListWithTabs.ready();
            } else {
                if (!storeWmRedBag.isShow && !storeWmEveryDayCoupon.isShow) {
                    const wmIndexBodyDom = dom.$id(wmDomId);
                    if (wmIndexBodyDom) {
                        wmIndexBodyDom.innerHTML = ErrorPage({
                            text: errorText,
                        });
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    });
};

const CrazyWaimaiModule = () => {
    const { structInfo } = storeCommon;
    const {
        dom_wm_red_bag: domWmRedBag,
        dom_wm_every_day_coupon: domWmEveryDayCoupon,
        dom_wm_self_promotion_order: domWmSelfPromotionOrder,
    } = structInfo.struct;

    const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
    const storeWmRedBag = store[domWmRedBag.recallBizId];
    const storeWmOrderCashBack = store[domWmSelfPromotionOrder.recallBizId];

    const couponList = [];
    if (storeWmRedBag.isShow) {
        couponList.push(...storeWmRedBag.discountData.redBagList);
    }
    if (storeWmEveryDayCoupon.isShow) {
        couponList.push(...storeWmEveryDayCoupon.discountData.couponList);
    }
    const isShowWaimaiCrazyCouponList =
        couponList.length > 0 &&
        (storeWmRedBag.isShow || storeWmEveryDayCoupon.isShow);

    const isShowWaimaiOrderCashBack = storeWmOrderCashBack.isShow;

    const {
        isShowCouponListFirst,
        couponListWelfareIndex,
        cashBackWelfareIndex,
    } = experimentIsShowCouponListPriority();

    const wmCouponListDom = isShowWaimaiCrazyCouponList
        ? WaimaiCrazyCouponList({ welfareIndex: couponListWelfareIndex })
        : '';

    const wmOrderCashBackDom = isShowWaimaiOrderCashBack
        ? OrderCashBack({ welfareIndex: cashBackWelfareIndex })
        : '';

    const data = {
        firstDom: isShowCouponListFirst ? wmCouponListDom : wmOrderCashBackDom,
        secondDom: isShowCouponListFirst ? wmOrderCashBackDom : wmCouponListDom,
        tabsContainerId,
        poiListId,
        headerId,
    };

    const events = {};
    CrazyWaimaiModuleReady();
    return createComponent(tpl, { data, style }, events);
};

export default CrazyWaimaiModule;
